import Skeleton from "@/components/Skeleton";

/**
 * In-page placeholder for `Sections` (the category tiles), shown while its
 * client-side fetch runs.
 *
 * Mirrors the redesigned section exactly - tinted background, centred heading
 * with its accent rule underneath, and a 2/3-column grid of 4:3 rounded tiles -
 * so the placeholder and the real content occupy the same space and nothing
 * shifts when the data lands.
 */
export default function SectionsGridSkeleton({ tiles = 6 }: { tiles?: number }) {
  return (
    <section className="bg-[#F7FBFE]">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-14 lg:py-20">
        {/* Heading + accent rule, centred */}
        <div className="mb-10 flex flex-col items-center">
          <Skeleton className="h-9 w-56" />
          <Skeleton className="mt-3 h-1 w-16" shape="pill" />
        </div>

        <div className="grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-3">
          {Array.from({ length: tiles }).map((_, i) => (
            <Skeleton key={i} className="aspect-[4/3] w-full rounded-2xl" />
          ))}
        </div>
      </div>
    </section>
  );
}
